import { render, staticRenderFns } from "./systemSettings.vue?vue&type=template&id=1b5f52e4"
import script from "./systemSettings.vue?vue&type=script&lang=js"
export * from "./systemSettings.vue?vue&type=script&lang=js"
import style0 from "./systemSettings.vue?vue&type=style&index=0&id=1b5f52e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports